import { createContext, Dispatch, useContext, useState } from 'react';
import { ChildrenOnly } from '../../types/ChildrenOnly';

interface Controller {
  showingIndex: number | null;
  setShowingIndex: Dispatch<number | null>;
}

export const ShowingIndexContext = createContext<Controller | null>(null);

export const ShowingIndexProvider = ({ children }: ChildrenOnly) => {
  const [showingIndex, setShowingIndex] = useState<number | null>(null);
  return (
    <ShowingIndexContext.Provider value={{ showingIndex, setShowingIndex }}>
      {children}
    </ShowingIndexContext.Provider>
  );
};

export const useShowingIndex = (): Controller => {
  const indexController = useContext(ShowingIndexContext);

  if (!indexController) {
    throw new Error('useShowingIndex() called without a <ShowingIndexProvider /> ancestor');
  }

  return indexController;
};
